'use client'

import { useContext, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { LuMenu, LuX } from 'react-icons/lu'
import { Box, Flex, Menu, Portal, Text } from '@chakra-ui/react'

import CategoriesContext from 'contexts/CategoriesContext'

import CategoryMenuItem from './CategoryMenuItem'

const CategoriesMenu = (): JSX.Element => {
  const { t } = useTranslation('common')
  const { isLoading, categories } = useContext(CategoriesContext)

  const [isOpened, setIsOpened] = useState(false)

  const handleOpen = () => {
    setIsOpened(true)
  }

  const handleClose = () => {
    setIsOpened(false)
  }

  return (
    <Box hideBelow="lg">
      <Menu.Root size="md" open={isOpened} onInteractOutside={handleClose}>
        <Menu.Trigger
          onClick={() => (isOpened ? handleClose() : handleOpen())}
          color="green.a200"
          fontSize="sm"
          fontWeight={600}
          style={{ marginLeft: '16px', marginRight: '16px' }}
        >
          <Flex alignItems="center" gap={1}>
            <Box>
              <Text fontSize="lg" style={{ marginRight: '16px' }}>
                {isOpened ? <LuX /> : <LuMenu />}
              </Text>
            </Box>
            <Box>
              <Text fontSize="lg" style={{ whiteSpace: 'nowrap' }} fontWeight={'normal'}>
                {t('allProducts')}
              </Text>
            </Box>
          </Flex>
        </Menu.Trigger>
        <Portal>
          <Menu.Positioner>
            <CategoryMenuItem isLoading={isLoading} allCategories={categories} closeMenu={handleClose} />
          </Menu.Positioner>
        </Portal>
      </Menu.Root>
    </Box>
  )
}

export default CategoriesMenu
